settings_module = settings_module or {}
settings_module.rate = (lang)->

    Gettext._locale_data = {}
    gt.try_load_lang_po('/static/frontend_bat/app-backbone/locale/' + LOCALE_LOOKUP.gettext[lang] + '/messages.po')

    max_width = $("#content").width()

    # TODO:
    # - ve formiku musim zajistit ze se mi do switching hidden prvku dostane JSON s udaji o spinani
    # - upravit switching_handler tak, aby pri fadeIn vytahl udaje z formiku a vytvoril z nich novou instanci iniciovanou prave temito udaji;
    #   ale bacha, jen v pripadech ze jeste neexistuje
    # - fadeOut musi naopak aktualni stav ve JS widgetu uchovat ve formik poli

    $price0 = $('#id_price0')
    $price1 = $('#id_price1')
    $price2 = $('#id_price2')
    $rateswitching = $('#rateswitching')
    $switching = $('#id_switching')
    switching_widget = null

    $ratelabel = $('.rate-label')
    $currency = $('#id_currency')

    # Vrati symbol meny pro update labelu tarifu
    get_currency_symbol = (iso_code)->
        if not iso_code? or not _.isString(iso_code)
            return false

        details = CURRENCY_INFO[iso_code]

        if not _.isArray(details) or _.isEmpty(details)
            return false

        return _.last(details)[2]

    currency_switch_handler = ()->
        symbol = get_currency_symbol($currency.val())
        if not symbol
            $ratelabel.text("")
            return

        $ratelabel.text("#{symbol} / ")



    # Vrati seznam tarifu v podobe [{label:, id:}]. Jejich set vyhodnocuje podle policek priceX
    # ve formulari.
    get_rates = ()->
        levels = [
            val:$price0.val()
            label:$price0.closest('.form-group').find('label').text()
            id:0
        ,
            val:$price2.val()
            label:$price2.closest('.form-group').find('label').text()
            id:2
        ]
        x = _.reject(levels, (i)-> (_.isUndefined(i.val) || (i.val.length < 1) || _.isNaN(parseInt(i.val))))
        rates = _.map(x, (i)-> _.omit(i, 'val'))

        return rates

    # Vraci true, pokud ve formiku se zadavanim cen doslo k vyrazne zmene.
    # (coz je predpoklad k tomu, aby se kompletne prekreslil widget)
    cached_rates = null
    major_change_in_prices = ()->
        rates = get_rates()

        if _.isNull(cached_rates)
            cached_rates = _.map(rates, (i)-> i.id)
            return true

        _rates = _.map(rates, (i)-> i.id)

        out = ((cached_rates.length != _rates.length) ||
               (_.difference(cached_rates, _rates).length > 0))
        cached_rates = _rates
        return out

    # TODO:
    remove_widget = ()->
        if not _.isNull(switching_widget)
            json = switching_widget.get_switching_data() # TODO: nevim jestli to funguje jak ma; zkontrolovat
            $switching.val(JSON.stringify(json))
            switching_widget.close()
            switching_widget = null
        cached_rates = null

    # Obsluha policek se zadavanim ceny pro 1/2 level
    switching_handler = ()->
        if !major_change_in_prices()
            return

        rates = get_rates()

        rates_id_lut = _.map(rates, (i)-> i.id)
        if rates.length > 0
            if not _.isNull(switching_widget)
                remove_widget()

            # vyparsovani udaju o spinani ze skryteho policka formulare
            json = JSON.parse($switching.val())
            days = _.map(json.days, (i)->
                # prefiltrovani json dat jen na ty levely, pro ktere jsou ve formiku zadany ceny
                data = _.filter(i.data, (y)-> rates_id_lut.indexOf(y.level) != -1)
                i.data = data
                return i
            )
            config =
                place: '#switching_place'
                rates: rates
                days: days
                chart_params:
                    width: if max_width < 600 then max_width else undefined
            switching_widget = new SwitchingController(config)
            $rateswitching.fadeIn()
        else
            $rateswitching.fadeOut()
            remove_widget()

    $price0.on('change keyup', switching_handler)
    $price2.on('change keyup', switching_handler)
    switching_handler()
    $currency.on('change', currency_switch_handler)
    currency_switch_handler()

    $('#content form').submit ()->
        if switching_widget
            json = switching_widget.get_switching_data()
            $switching.val(JSON.stringify(json))
        return true
